import { Injectable, OnInit } from '@angular/core';
import { Dictionary } from './../base-models/dictionary';
import { BaseDataService } from './../base-services/base-data.service';
import { map } from 'rxjs/operators';
import { Observable, Subject, BehaviorSubject } from 'rxjs';
import { CryptoService } from './crypto.service';

@Injectable({
    providedIn: 'root'
  })

export class DefgIniService 
{
    constructor(
        protected baseDataService: BaseDataService
        // protected httpClient: HttpClient,
        // protected configService: ConfigService,
        // protected loaderService: LoaderService
    ){}  
   

    private dict = new Dictionary();
    private keyType=new Dictionary();
    isDefginiSetSubject = new BehaviorSubject<boolean>(false);
    isDefginiSetObservable = this.isDefginiSetSubject.asObservable();

    ngOnDestroy() {
        this.dict = null;
        this.keyType = null;
    }
    
    LoadDefgIniData() : Observable<any>{
        return this.baseDataService.GetData('defgini', 'GetDefgIniByOrgJedId', null)
            //.subscribe((data) => {
            .pipe(map((data) => {
                for (let row in data){
                    this.dict.add(row, data[row]);
                }
                this.LoadDefgIniTypesData();
            }
            , () => {
                // this.error = true;
            })
        );

        // const allPromise = Promise.all([
        //     this.baseDataService.GetData('defgini', 'GetDefgIniByOrgJedId', null)
        //     // .subscribe((data) => {
        //     //     for (let row in data){
        //     //         this.dict.set(row, data[row]);
        //     //     }

        //     // }
        //     // , () => {
        //     //     // this.error = true;
        //     // }
        //     // )
        //     , this.baseDataService.GetData('defgini', 'GetDefgIniKeyTypeByOrgJedId', null)
        //     // .subscribe((data) => {
        //     //     for (let row in data){
        //     //         this.keyType.set(row, data[row]);
        //     //     }
        //     // }
        //     // , () => {
        //     //     // this.error = true;
        //     // }
        //     // )
        // ])

        // try {
        //     const values=await allPromise;
        // } catch (error){
        //     error;
        // }

        // .then((data)=>{
        //     // Tipiziramo vrednosti ključa
        //     for (let row in this.dict){
        //         this.dict.set(row, this.ConvStrToProperType(this.dict.get(row), this.keyType.get(row)));
        //     }
        // })

        // for (let row in defginiValues){
        //     this.dict.set(row, defginiValues[row]);
        // }

        // for (let row in defginiTypes){
        //     this.keyType.set(row, defginiTypes[row]);
        // }        

        // for (let row in defginiValues){
        //     this.dict.set(row, defginiValues[row]);
        //     // this.dict.set(row, this.ConvStrToProperType(this.dict.get(row), row));
        // }
    }

    private LoadDefgIniTypesData(){
        this.baseDataService.GetData('defgini', 'GetDefgIniKeyType', null)
        .subscribe((data) => {
            for (let row in data){
                this.keyType.add(row, data[row]);
            }
          this.ConvertDefginiValueTypes();
          const encrypt = CryptoService.Encrypt(this.dict);

          sessionStorage.setItem('defgini', encrypt);
          this.isDefginiSetSubject.next(true);
        }
        , () => {
            // this.error = true;
        }
        );
    }

    private ConvertDefginiValueTypes(){
        for (let row in this.dict.items){
            this.dict.set(row, this.ConvStrToProperType(this.dict.get(row), this.keyType.get(row)));
        }
    }

    ConvStrToProperType(strValue, propType: string){
        switch(propType){
            case "bit":            
                switch(strValue){
                    case true:
                    case "true":
                    case "True":
                    case 1:
                    case "1":
                    case "on":
                    case "yes":
                        return true;
                    default: 
                        return false;
                }
            default:
                return strValue
        }
    }


    GetByKey(key: string){
        // if (this.dict.lenght==0)
        //     this.LoadDefgIniData();

        // if (key=="g_eRegistrator")
        // {
        //     if (this.dict.get(key)=="True")
        //         return true;
        //     else
        //         return false;
        // }
        // else
        //     return this.dict.get(key);

        if(this.dict == null || this.dict.lenght == 0) {
          this.dict.items = (CryptoService.Decrypt(sessionStorage.getItem('defgini')) as Dictionary).items;
          this.dict.lenght = (CryptoService.Decrypt(sessionStorage.getItem('defgini')) as Dictionary).lenght;
        }

        return this.dict.get(key);
    }

}

